import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App.js';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
      networkMode: 'always',
      /*
        Explicit, because 'always' turns it off: React Query stops treating a reconnect as a reason to
        reload. The seating board relies on that reload to show what changed while the phone was
        offline.
      */
      refetchOnReconnect: true,
    },
    /*
      ALWAYS TRY, AND FAIL OUT LOUD (2026-10-19). React Query's default pauses anything started while
      the phone reports itself offline: a Save sat at "Saving…" with nothing else on the screen, and
      then went through on its own whenever the signal came back. Tried at once, it fails with
      "Couldn't connect" (lib/api.ts) and she decides when to press it again.
    */
    mutations: {
      networkMode: 'always',
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
